import { Badge, Box, Text } from '@mantine/core'

import * as DisplayData from '@/components/commons/DisplayData'
import { PriceRange as PriceRangeType } from '@/types'

interface Props {
  priceRange: PriceRangeType
}

export default function PriceVariation({ priceRange }: Props) {
  const { minimalSellingQuantity, sellingPrice, type } = priceRange.lowest

  return (
    <>
      <Text size="sm">A partir de</Text>
      <Text size="lg" fw="bold">
        <DisplayData.CurrencyField value={sellingPrice} />
        {type === 'tuition' && '/mês'}
        {type === 'contract' && '/contrato'}
      </Text>
      {/* {discountAmount && discountAmount !== 0 && (
        <Text color="blue">
          Desconto <DisplayData.CurrencyField value={discountAmount} />
        </Text>
      )} */}
      {minimalSellingQuantity > 1 && (
        <Box my={1}>
          <Badge color="primary">Mínimo {minimalSellingQuantity} un.</Badge>
        </Box>
      )}
    </>
  )
}
